(function () {
  // Domains treated as "ours" — links to these are left alone.
  const OWN_HOSTS = [
    window.location.hostname,
    'insanefits.com',
    'www.insanefits.com',
    'insanefits.myshopify.com'
  ];

  // External domains that should NOT get target/rel — e.g. own social profiles.
  const SKIP_HOSTS = [
    'facebook.com',
    'instagram.com',
    'tiktok.com',
    'youtube.com'
  ];

  function isInternal(link) {
    return OWN_HOSTS.includes(link.hostname);
  }

  function isSkipped(link) {
    const host = link.hostname.replace(/^www\./, '');
    return SKIP_HOSTS.some((h) => host === h || host.endsWith('.' + h));
  }

  function process(link) {
    if (!link.href) return;
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return; // skips mailto:, tel:, #anchors
    if (isInternal(link)) return;
    if (isSkipped(link)) return;
    if (link.closest('[data-skip-external-links]')) return;
    if (link.dataset.externalProcessed) return;

    link.setAttribute('target', '_blank');

    const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    rel.add('nofollow');
    rel.add('noopener');
    link.setAttribute('rel', [...rel].join(' '));

    link.dataset.externalProcessed = 'true';
  }

  function processAll(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.tagName === 'A') process(root);
    root.querySelectorAll('a[href]').forEach(process);
  }

  function init() {
    processAll(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((m) => m.addedNodes.forEach(processAll));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();